<template>
  <div>
    登录中
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  mounted() {
  },
  created() {
    const token = this.$route.query.token
    console.log('---------------token')
    this.$store.commit('token', token)
    this.$store.commit('token', token)
    this.getToken(token)
  },
  methods: {
    // 获取token
    getToken(n, e) {
      this.axios
        .get('/sys/v1/user/getInfo?winType=1', {
          headers: {
            isLoading: false
          }
        })
        .then((res) => {
          console.log(res)
          if (e == 1 && res) {//e == 1 ---表示登录并绑定旧账号按钮
            this.setPasswordDialogVisible = true;
          }
          //if (res.data.dingId == '' && res.data.userType !== '1') {
          //  this.$message.warning('请使用钉钉账号登录系统！')
          //  return false
          //} else if (e == 1 && res) {
          //  this.setPasswordDialogVisible = true
          //  return false
          //}

          if (res.data.flag == 0 && e == 2) { // firstLogin=（1--钉钉首次登录）（0--不是钉钉首次登录） e == 1 登录并绑定  e==2 登录按钮
            // this.firstDialogVisible = true
            return false
          }
          if (res.code == 0) {
            this.$store.commit('user_id', res.data.id)

            this.axios.get(`/sys/v1/user/employee/get/roleNames?employeeId=` + res.data.id).then((res) => {
              sessionStorage.setItem('role', res.data)
            })

            let array = ''
            if (this.is_null(res.data.salesAuthorityId)) {
              array = ''
            } else {
              array = res.data.salesAuthorityId
            }
            console.log('----------array', array)
            this.$store.commit('salesAuthorityId', array)
            const sess = {
              parentOrgName: res.data.parentOrgName,
              orgName: res.data.orgName,
              reallyName: res.data.reallyName,
              positionName: res.data.positionName,
              img: res.data.avatarUrl
            }
            sessionStorage.setItem('personInfo', JSON.stringify(sess))
            sessionStorage.setItem('positionCode', res.data.positionCode)
            sessionStorage.setItem('orgCode', res.data.orgCode)
            sessionStorage.setItem(
              'orgCodes',
              JSON.stringify(res.data.orgCodes)
            )
            sessionStorage.setItem('userInfo', JSON.stringify(res.data))
            // this.$message({ type: "success", message: "登录成功" });
            this.limits()
          } else {
            this.$message({ type: 'warning', message: res.message })
          }
        })
    },
    // 权限处理
    limits() {
      this.axios
        .get('/sys/v1/menu/button/user/tree?winType=1', {
          headers: {
            isLoading: false
          }
        })
        .then((res) => {
          console.log(res)
          if (res.code == 0) {
            sessionStorage.setItem('limit', JSON.stringify(res.data))
            if (res.data.menuTreeList) {
              console.log(res)
              const juade = res.data.menuTreeList.find(
                (res) => res.code == 'index'
              )
              console.log(juade, 'juade')
              if (juade) {
                // this.$router.replace('home')
                this.$router.replace('home/welcome') // 如果没有配置菜单权限就跳到欢迎页面
              } else {
                if (res.data.menuTreeList[0].children) {
                  this.$router.replace(res.data.menuTreeList[0].children[0].jumpUrl)
                } else {
                  this.$router.replace(res.data.menuTreeList[0].jumpUrl)
                }
              }
            } else {
              this.$message({ type: 'warning', message: res.message })
            }
          } else {
            if (res.code == 103) {
              sessionStorage.setItem('limit', JSON.stringify({}))
              this.$router.replace('home/welcome') // 如果没有配置菜单权限就跳到欢迎页面
            }
            // this.$message({ type: "warning", message: res.message });
          }
        })
    },
    is_null(content) {
      if (content) {
        return false
      } else {
        return true
      }
    }
  }
}
</script>
<style scoped lang="scss"></style>
